<template>
  <div class="home-container">
    <div class="home-hero">
      <div class="hero-left">
        <h1>创新科技 · 为丰收赋能</h1>
        <p>农化客户管理平台，链接一线田间与研发工厂，统一管理客户、拜访与服务数据。</p>
      </div>
      <div class="hero-right">
        <div class="hero-badge">农化 · NH AGRO</div>
        <div class="hero-tags">
          <span>植物生长调节剂</span>
          <span>肥料与营养</span>
          <span>园林植保</span>
        </div>
      </div>
    </div>

    <div class="page-header">
      <div class="page-title-block">
        <h2>工作台 · 门户</h2>
        <p class="page-subtitle">快速进入客户、回访、地图与团队管理，助力一线农资服务</p>
      </div>
    </div>

    <div class="portal-grid" :class="{ 'is-mobile': isMobile }">
      <div
        v-for="item in visiblePortalItems"
        :key="item.key"
        class="portal-card"
        :class="'theme-' + item.theme"
        @click="go(item.path)"
      >
        <div class="card-icon">
          <i :class="item.icon"></i>
        </div>
        <div class="card-content">
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
        <div class="card-footer">
          <span>进入</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'Home',
  data() {
    return {
      isMobile: false,
      portalItems: [
        {
          key: 'customers',
          title: '客户列表',
          desc: '查看和管理所有种植户、经销商与门店信息',
          icon: 'el-icon-s-custom',
          path: '/customers',
          theme: 'green'
        },
        {
          key: 'addCustomer',
          title: '新增客户',
          desc: '快速录入新的客户档案与定位信息',
          icon: 'el-icon-plus',
          path: '/customers/new',
          theme: 'blue'
        },
         {
          key: 'visit',
          title: '新增回访记录',
          desc: '记录本次用药、用肥效果与现场图片',
          icon: 'el-icon-notebook-1',
          path: '/visit-records/new',
          theme: 'orange'
        },
        {
          key: 'map',
          title: '客户地图',
          desc: '在地图上直观查看客户分布与拜访路线',
          icon: 'el-icon-location-outline',
          path: '/map',
          theme: 'cyan'
        },
        {
          key: 'customerRecycleBin',
          title: '客户回收站',
          desc: '查看并恢复已逻辑删除的客户数据',
          icon: 'el-icon-delete',
          path: '/customers/recycle-bin',
          theme: 'orange'
        },
        {
          key: 'users',
          title: '用户管理',
          desc: '维护销售、技术服务等内部成员账号',
          icon: 'el-icon-user-solid',
          path: '/users',
          theme: 'purple'
        },
        {
          key: 'departments',
          title: '部门管理',
          desc: '配置战区与部门架构，支撑精细化管理',
          icon: 'el-icon-office-building',
          path: '/departments',
          theme: 'teal'
        },
        {
          key: 'roles',
          title: '角色管理',
          desc: '配置系统角色与菜单权限，精细控制访问范围',
          icon: 'el-icon-s-tools',
          path: '/roles',
          theme: 'purple'
        },
        {
          key: 'menus',
          title: '菜单管理',
          desc: '维护左侧导航与工作台入口菜单',
          icon: 'el-icon-menu',
          path: '/menus',
          theme: 'blue'
        }
       
      ],
      allowedPaths: []
    }
  },
  computed: {
    // 根据当前用户有权限的菜单，过滤工作台卡片
    visiblePortalItems() {
      if (!this.allowedPaths || this.allowedPaths.length === 0) {
        return []
      }
      return this.portalItems.filter(item => this.allowedPaths.includes(item.path))
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    this.loadAllowedMenus()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768
    },
    loadAllowedMenus() {
      // 与侧边菜单相同的权限接口
      request.get('/menus/current')
        .then(res => {
          const menus = res.data || res
          this.allowedPaths = (menus || []).map(m => m.path)
        })
        .catch(err => {
          console.error('加载当前用户菜单失败:', err)
          // 失败时不阻塞页面，只是暂时不显示工作台入口
          this.allowedPaths = []
        })
    },
    go(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.home-container {
  width: 100%;
}

.home-hero {
  position: relative;
  margin-bottom: 18px;
  padding: 18px 20px;
  border-radius: 18px;
  color: #fff;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  background-image: linear-gradient(135deg, #0f9bd7 0%, #17b676 40%, #0f8f59 100%);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.22);
}

.home-hero::before {
  content: '';
  position: absolute;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  right: -60px;
  top: -40px;
}

.home-hero::after {
  content: '';
  position: absolute;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  right: -30px;
  bottom: -80px;
}

.hero-left {
  position: relative;
  z-index: 1;
  max-width: 60%;
}

.hero-left h1 {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 600;
}

.hero-left p {
  margin: 0;
  font-size: 13px;
  line-height: 1.7;
  opacity: 0.95;
}

.hero-right {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.hero-badge {
  padding: 6px 12px;
  border-radius: 999px;
  background-color: rgba(0, 0, 0, 0.15);
  font-size: 11px;
  letter-spacing: 1px;
}

.hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
}

.hero-tags span {
  padding: 4px 10px;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.18);
  font-size: 11px;
}

.page-header {
  margin-bottom: 18px;
  padding: 6px 4px 10px;
}

.page-title-block h2 {
  margin: 0;
  color: #0f8f59;
  font-size: 22px;
}

.page-subtitle {
  margin-top: 4px;
  font-size: 12px;
  color: #80848f;
}

.portal-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.portal-grid.is-mobile {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.portal-card {
  position: relative;
  padding: 16px 14px 10px;
  border-radius: 16px;
  color: #fff;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 120px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.portal-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 0 0, rgba(255, 255, 255, 0.16), transparent 50%),
              radial-gradient(circle at 100% 100%, rgba(255, 255, 255, 0.16), transparent 55%);
  pointer-events: none;
}

.portal-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}

.card-icon {
  font-size: 30px;
  margin-bottom: 8px;
}

.card-content h3 {
  margin: 0 0 4px;
  font-size: 16px;
}

.card-content p {
  margin: 0;
  font-size: 12px;
  opacity: 0.92;
}

.card-footer {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  gap: 4px;
  opacity: 0.95;
}

.card-footer i {
  font-size: 13px;
}

.theme-green {
  background-image: linear-gradient(135deg, #17b676, #0f8f59);
}

.theme-blue {
  background-image: linear-gradient(135deg, #0f9bd7, #17b676);
}

.theme-cyan {
  background-image: linear-gradient(135deg, #00bcd4, #0f9bd7);
}

.theme-orange {
  background-image: linear-gradient(135deg, #ff9f43, #ff6b6b);
}

.theme-purple {
  background-image: linear-gradient(135deg, #7c4dff, #0f9bd7);
}

.theme-teal {
  background-image: linear-gradient(135deg, #009688, #17b676);
}

@media (max-width: 768px) {
  .home-container {
    padding: 0 4px;
  }
  .home-hero {
    flex-direction: column;
    align-items: flex-start;
    padding: 14px 12px;
  }
  .hero-left {
    max-width: 100%;
  }
  .hero-left h1 {
    font-size: 20px;
  }
  .portal-card {
    min-height: 110px;
    padding: 14px 12px 8px;
  }
}
</style>

